module.exports = __webpack_public_path__ + "static/media/backtracking.440cc58f.svg";